import React from "react";

import IconTooltip from "root/UI/Tooltip/IconTooltip";
import {Link} from "react-router-dom";

export const defaultSearchBarStyle = {
    height: "30px",
    width: "25vw",
    margin: "20px",
    float: 'right',
    backgroundColor: "#edf4f9"
} ;

export const defaultTopLeftCellStyle = "5px 0px 0px 0px" ;
export const defaultTopRightCellStyle = "0px 5px 0px 0px" ;

export const defaultTableHeaderStyles = {
    backgroundColor: "var(--vschool-2026-header)",
    textAlign: "left",
    border: "0",
    fontSize: "14px"
} ;

export const defaultPaginationOptions = {
    sizePerPage: 15,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    showTotal: true,
    className: "neil-pager"
};

export const extendedPaginationOptions = {
    sizePerPage: 15,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    showTotal: true,
    className: "neil-pager"
};

export const defaultTableOptions = {
striped: true ,
bordered: false,
hover: true,
rowStyle: {
    color: "#605F5E",
    textAlign: "left",
    fontSize: "14px",
    margin: "10px"
}} ;

export const customHeaderStyle = (headerStyles, column, colIndex) => {

    const name = column.dataField ;

    let style = headerStyles.default ;

    if ( headerStyles[name] !== undefined )
    {
        style = { ...style, ...headerStyles[name]} ;
    }

    return style ;
};

export const addStyle = ( defaultStyle, additional ) =>
{
    return { ...defaultStyle, ...additional } ;
}

export const TableActionIconGeneric = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: '10px'}}
                            placement='top' text={props.text} icon={props.icon} color={props.color}/>
    }
    else if ( props.href !== null && props.href !== undefined )
    {
        return  <a href={props.href} target={props.target} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                                                      icon={props.icon}
                                                                                                      color={props.color}/></a>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                              icon={props.icon}
                                                                              color={props.color}/></Link>
        }
    }
}

export const TableActionIconViewPDF = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: '10px'}}
                            placement='top' text={props.text} icon="glyphicon-file" color="var(--s360-icon-blue)"/>
    }
    else if ( props.href !== null && props.href !== undefined )
    {
        return  <a href={props.href} target={props.target} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                          icon="glyphicon-file"
                                                                          color="var(--s360-icon-blue)"/></a>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={url} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                              icon="glyphicon-file"
                                                                              color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconEdit = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: '10px'}}
                            placement='top' text={props.text} icon="glyphicon-pencil" color="var(--s360-icon-blue)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={url} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                              icon="glyphicon-pencil"
                                                                              color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconView = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: '10px'}}
                            placement='top' text={props.text} icon="glyphicon-eye-open" color="var(--s360-icon-green)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                              icon="glyphicon-eye-open"
                                                                              color="var(--s360-icon-green)"/></Link>
        }
    }
}

export const TableActionIconDelete = ( props ) =>
{
    const addStyle = props.style === undefined ? {} : props.style ;

    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: '10px', ...addStyle}}
                            placement='top' text={props.text} icon="glyphicon-trash" color="var(--s360-icon-red)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                                   icon="glyphicon-trash"
                                                                                   color="var(--s360-icon-red)"/></Link>
        }
    }
}